// Height of a ActionPlanTitleBar + ActionPlanTopBar in the Feedback component + navigation
export const headerHeight = 92;
export const headerHeightFeedback = 56;
export const expandedHeaderHeight = 100;
export const footerHeight = 100;
